var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeginnerLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 6C7.99084 6 9.33398 4.65685 9.33398 3C9.33398 1.34315 7.99084 0 6.33398 0C4.67713 0 3.33398 1.34315 3.33398 3C3.33398 4.65685 4.67713 6 6.33398 6Z",
    fill: "#6E727F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 7C15.2147 7 16.334 5.88071 16.334 4.5C16.334 3.11929 15.2147 2 13.834 2C12.4533 2 11.334 3.11929 11.334 4.5C11.334 5.88071 12.4533 7 13.834 7Z",
    fill: "#6E727F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949264 14.428C0.55196 14.1736 0.321832 13.721 0.380034 13.2529C0.748142 10.292 3.27342 8 6.33388 8C9.39434 8 11.9196 10.2914 12.2877 13.2522C12.3459 13.7203 12.1158 14.1729 11.7185 14.4273C10.1642 15.4225 8.31642 16 6.33388 16C4.35136 16 2.50357 15.4231 0.949264 14.428Z",
    fill: "#6E727F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 14C13.7987 14 13.7635 13.9998 13.7283 13.9993C13.7971 13.7025 13.8162 13.3885 13.7762 13.0671C13.6008 11.6562 13.0341 10.367 12.188 9.31165C12.6986 9.11049 13.2548 9 13.8368 9C15.7765 9 17.4296 10.2273 18.0619 11.9478C18.1978 12.3176 18.0385 12.7241 17.7011 12.9275C16.5719 13.6083 15.2487 14 13.834 14Z",
    fill: "#6E727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginnerLogo2);
export default __webpack_public_path__ + "static/media/BeginnerLogo2.b4ceb5b1a408bebc97f7bae3b7a9d3d2.svg";
export { ForwardRef as ReactComponent };